import { service } from "../utils/request";

//会员等级列表
export function vipList(data) {
  return service({
    url: "user/agent.user_level/index",
    method: "post",
    data: data
  });
}

//删除会员等级
export function delList(data) {
  return service({
    url: "user/agent.user_level/del",
    method: "post",
    data: data
  });
}

//获取任务类型
export function taskTypeList(data) {
  return service({
    url: "user/agent.user_level_task/taskType",
    method: "post",
    data: data
  });
}
//收款码编辑
export function qrcodeEdit(data) {
  return service({
    url: "offlinestore/agent.qrcode/edit",
    method: "post",
    data: data
  });
}
//收款码详情
export function qrcodeInfo(data) {
  return service({
    url: "offlinestore/agent.qrcode/detail",
    method: "post",
    data: data
  });
}
//结算时间显示
export function settletime(data) {
  return service({
    url: "manage/config.duty_settle_time/settletime",
    method: "post",
    data: data
  });
}
//结算时间详情
export function editsettletimeDetail(data) {
  return service({
    url: "manage/config.duty_settle_time/editDetail",
    method: "post",
    data: data
  });
}
//保存结算时间
export function saveSettletime(data) {
  return service({
    url: "manage/config.duty_settle_time/saveConfig",
    method: "post",
    data: data
  });
}

//添加会员等级
export function addLevel(data) {
  return service({
    url: "user/agent.user_level/add",
    method: "post",
    data: data
  });
}

//编辑会员等级
export function editLevel(data) {
  return service({
    url: "user/agent.user_level/edit",
    method: "post",
    data: data
  });
}

//会员等级详情
export function detailLevel(data) {
  return service({
    url: "user/agent.user_level/detail",
    method: "post",
    data: data
  });
}

//会员等级任务列表
export function getTaskList(data) {
  return service({
    url: "user/agent.user_level_task/tashList",
    method: "post",
    data: data
  });
}

//会员等级任务添加
export function addTask(data) {
  return service({
    url: "user/agent.user_level_task/add",
    method: "post",
    data: data
  });
}

//会员等级任务编辑
export function editTask(data) {
  return service({
    url: "user/agent.user_level_task/edit",
    method: "post",
    data: data
  });
}

//会员等级任务删除
export function delTask(data) {
  return service({
    url: "user/agent.user_level_task/del",
    method: "post",
    data: data
  });
}

//会员卡组列表
export function levelGroupList(data) {
  return service({
    url: "user/agent.user_level_group/index",
    method: "post",
    data: data
  });
}

//会员卡组添加
export function levelGroupAdd(data) {
  return service({
    url: "user/agent.user_level_group/add",
    method: "post",
    data: data
  });
}

//会员卡组修改
export function levelGroupEdit(data) {
  return service({
    url: "user/agent.user_level_group/edit",
    method: "post",
    data: data
  });
}

//会员卡组删除
export function levelGroupDel(data) {
  return service({
    url: "user/agent.user_level_group/del",
    method: "post",
    data: data
  });
}

//会员卡组详情
export function levelGroupDetail(data) {
  return service({
    url: "user/agent.user_level_group/detail",
    method: "post",
    data: data
  });
}

// 会员卡组下的用户id
export function levelGroupUids(data) {
  return service({
    url: "user/agent.user_level_group/users",
    method: "post",
    data: data
  });
}

/* 设备管理 */
//设备列表
export function equipmentList(data) {
  return service({
    url: "offlinestore/agent.cate/index",
    method: "post",
    data: data
  });
}

//添加设备
export function equipmentAdd(data) {
  return service({
    url: "offlinestore/agent.cate/add",
    method: "post",
    data: data
  });
}

//修改设备
export function equipmentEdit(data) {
  return service({
    url: "offlinestore/agent.cate/edit",
    method: "post",
    data: data
  });
}

//删除设备
export function equipmentDel(data) {
  return service({
    url: "offlinestore/agent.cate/del",
    method: "post",
    data: data
  });
}
//会员统计(新)
export function new_Vipstatistics(data) {
  return service({
    url: "user/agent.User_level_card/statistics",
    method: "post",
    data: data
  });
}

/* 产品管理 */
//产品列表
export function goodsList(data) {
  return service({
    url: "offlinestore/agent.goods/index",
    method: "post",
    data: data
  });
}
//抽奖
export function luck_draw(data) {
  return service({
    url: "manage/prize.prize/add",
    method: "post",
    data: data
  });
}
export function luck_Data(data) {
  return service({
    url: "manage/prize.prize/index",
    method: "get",
    params: data
  });
}
export function edit_baseinfo(data) {
  return service({
    url: "manage/prize.prize/edit_baseinfo",
    method: "post",
    data: data
  });
}
export function winning_Data(data) {
  return service({
    url: "manage/prize.order/index",
    method: "get",
    params: data
  });
}
//核销
export function consume(data) {
  return service({
    url: "manage/prize.order/consume",
    method: "post",
    data: data
  });
}
export function edit_status(data) {
  return service({
    url: "manage/prize.prize/disable",
    method: "post",
    data: data
  });
}
export function lottery_detail(data) {
  return service({
    url: "manage/prize.prize/detail",
    method: "get",
    params: data
  });
}
export function lottery_edit(data) {
  return service({
    url: "manage/prize.prize/edit",
    method: "post",
    data: data
  });
}
export function lottery_del(data) {
  return service({
    url: "manage/prize.prize/del",
    method: "post",
    data: data
  });
}
export function winn_status(data) {
  return service({
    url: "manage/prize.order/status",
    method: "post",
    data: data
  });
}
export function del_winn(data) {
  return service({
    url: "manage/prize.order/del",
    method: "post",
    data: data
  });
}
export function winn_detail(data) {
  return service({
    url: "manage/prize.order/detail",
    method: "get",
    params: data
  });
}

//产品删除
export function goodsDel(data) {
  return service({
    url: "offlinestore/agent.goods/del",
    method: "post",
    data: data
  });
}

//产品添加
export function goodsAdd(data) {
  return service({
    url: "offlinestore/agent.goods/add",
    method: "post",
    data: data
  });
}

//产品修改
export function goodsEdit(data) {
  return service({
    url: "offlinestore/agent.goods/edit",
    method: "post",
    data: data
  });
}

//产品详情
export function goodsDetail(data) {
  return service({
    url: "offlinestore/agent.goods/detail",
    method: "post",
    data: data
  });
}

/* 下拉菜单 */
// 产品下拉菜单
export function goodsOptions(data) {
  return service({
    url: "offlinestore/agent.goods/select",
    method: "post",
    data: data
  });
}

// 油品类别下拉菜单
export function oilsTypeOptions(data) {
  return service({
    url: "offlinestore/agent.type/select",
    method: "post",
    data: data
  });
}

//员工下拉菜单
export function employeeOptions(data) {
  return service({
    url: "offlinestore/agent.employee/select",
    method: "post",
    data: data
  });
}

//设备下拉菜单
export function equipmentOptions(data) {
  return service({
    url: "offlinestore/agent.cate/select",
    method: "post",
    data: data
  });
}

//生成的二维码列表
export function qrcodeList(data) {
  return service({
    url: "offlinestore/agent.qrcode/lst",
    method: "post",
    data: data
  });
}

//充值设置列表
export function voucherSetList(data) {
  return service({
    url: "api/config.recharge/index",
    method: "post",
    data: data
  });
}

//充值设置新增
export function voucherSet(data) {
  return service({
    url: "api/config.recharge/setConfig",
    method: "post",
    data: data
  });
}
//会员卡组下拉菜单
export function levelGroupSelect(data) {
  return service({
    url: "user/agent.user_level/select",
    method: "post",
    data: data
  });
}

/* 会员管理 */
//会员列表
export function vipUserList(data) {
  return service({
    url: "user/agent.User_level_card/index",
    method: "post",
    data: data
  });
}
//会员统计(新)
export function vipstatistic_new(data) {
  return service({
    url: "user/agent.User_level_card/statistics",
    method: "post",
    data: data
  });
}
//普通订单打印
export function print_normal_order(data) {
  return service({
    url: "manage/order.normal_order/print_normal",
    method: "post",
    data: data
  });
}
//买单会员信息
export function vipUserinfo(data) {
  return service({
    url: "manage/order.offline_order/info",
    method: "post",
    data: data
  });
}
//买单优惠信息
export function oderYH(data) {
  return service({
    url: "manage/order.offline_order/compute",
    method: "post",
    data: data
  });
}

//会员详情
export function vipUserDetail(data) {
  return service({
    url: "user/agent.User_level_card/detail",
    method: "post",
    data: data
  });
}

//修改会员信息
export function vipUserEdit(data) {
  return service({
    url: "user/agent.User/edit",
    method: "post",
    data: data
  });
}

//修改会员账户积分
export function vipAccountEdit(data) {
  return service({
    url: "user/agent.User/operate_account",
    method: "post",
    data: data
  });
}

// 获取开卡设置
export function getOpenSet(data) {
  return service({
    url: "user/agent.Users_Card_Set/detail",
    method: "post",
    data: data
  });
}

//修改开卡设置
export function setOpenSet(data) {
  return service({
    url: "user/agent.Users_Card_Set/edit",
    method: "post",
    data: data
  });
}

//订单列表
export function vipOrderList(data) {
  return service({
    url: "offlinestore/agent.order/index",
    method: "post",
    data: {
      ...data,
      request: "pc"
    }
  });
}

//充值列表
export function voucherList(data) {
  return service({
    url: "offlinestore/agent.recharge/index",
    method: "post",
    data: data
  });
}
//充值订单退款
export function refund_recharge(data) {
  return service({
    url: "manage/order.recharge/refund",
    method: "post",
    data: data
  });
}
//充值订单退款状态
export function refund_status(data) {
  return service({
    url: "manage/order.recharge/refundStatus",
    method: "post",
    data: data
  });
}
//油品订单退款
export function offline_orderRefund(data) {
  return service({
    url: "manage/order.offline_order/refund",
    method: "post",
    data: data
  });
}
//油品订单退款状态
export function offline_order_status(data) {
  return service({
    url: "manage/order.offline_order/refundStatus",
    method: "post",
    data: data
  });
}
//概况
export function general(data) {
  return service({
    url: "offlinestore/agent.count/index",
    method: "post",
    data: data
  });
}

//添加文章
export function addArticle(data) {
  return service({
    url: "user/agent.userlevelarticle/add",
    method: "post",
    data: data
  });
}

//文章列表
export function ArticleList(data) {
  return service({
    url: "user/agent.userlevelarticle/index",
    method: "post",
    data: data
  });
}

//文章删除
export function ArticleDel(data) {
  return service({
    url: "user/agent.userlevelarticle/del",
    method: "post",
    data: data
  });
}

//文章编辑
export function ArticleEdit(data) {
  return service({
    url: "user/agent.userlevelarticle/edit",
    method: "post",
    data: data
  });
}

//预约列表
export function appointList(data) {
  return service({
    url: "offlinestore/agent.Offlineapply/index",
    method: "post",
    data: data
  });
}

//预约列表
export function appointDel(data) {
  return service({
    url: "/offlinestore/agent.Offlineapply/del",
    method: "post",
    data: data
  });
}

// 添加油品类别
export function addOilSort(token, app_id, name) {
  return service({
    url: "offlinestore/agent.type/add",
    method: "post",
    data: {
      token,
      app_id,
      name
    }
  });
}

// 油品类名列表
export function getOilSortList(token, app_id, store_id, room_id, name) {
  return service({
    url: "offlinestore/agent.type/index",
    method: "post",
    data: {
      token,
      app_id,
      store_id,
      room_id,
      name
    }
  });
}

// 删除类别
export function delOilSort(token, app_id, id) {
  return service({
    url: "offlinestore/agent.type/del",
    method: "post",
    data: {
      token,
      app_id,
      id
    }
  });
}

// 编辑类别
export function editOilSort(token, app_id, id, name) {
  return service({
    url: "offlinestore/agent.type/edit",
    method: "post",
    data: {
      token,
      app_id,
      id,
      name
    }
  });
}

// 油品类别下拉内容
export function getSelectArr(token, app_id, store_id) {
  return service({
    url: "offlinestore/agent.type/select",
    method: "post",
    data: {
      token,
      app_id,
      store_id
    }
  });
}

// 会员开卡
export function vipOpenCard(data) {
  return service({
    url: "user/agent.user_level_card/add_user",
    method: "post",
    data: data
  });
}

// 油品订单
export function oilsOrder(data) {
  return service({
    url: "offlinestore/agent.order/index",
    method: "post",
    data: {
      ...data,
      request: "pc"
    }
  });
}

//当前班次订单列表
export function vipOrderListNow(data) {
  return service({
    url: "offlinestore/agent.Order/current_shift_lists",
    method: "post",
    data: data
  });
}

//最近班次订单列表
export function last_shift_lists(data) {
  return service({
    url: "offlinestore/agent.Order/last_shift_lists",
    method: "post",
    data: data
  });
}

//普通订单列表
export function vipOrdinaryList(data) {
  return service({
    url: "manage/order.normal_order/index",
    method: "post",
    data: data
  });
}
//油品退款订单列表
export function offline_refundList(data) {
  return service({
    url: "manage/order.offline_order/refundList",
    method: "post",
    data: data
  });
}
//充值退款订单列表
export function recharge_refundList(data) {
  return service({
    url: "manage/order.recharge/refundList",
    method: "post",
    data: data
  });
}
//普通订单退款列表
export function normalOrder_refundList(data) {
  return service({
    url: "manage/order.normal_order/refundList",
    method: "post",
    data: data
  });
}
//普通订单退款
export function normalOrder_refund(data) {
  return service({
    url: "manage/order.normal_order/refund",
    method: "post",
    data: data
  });
}
//普通订单退款状态
export function normalOrder_refundStatus(data) {
  return service({
    url: "manage/order.normal_order/refundStatus",
    method: "post",
    data: data
  });
}
// 油品异常订单
export function oilsErrorOrder(data) {
  return service({
    url: "offlinestore/agent.order/errorOrder",
    method: "post",
    data: data
  });
}

// 油品异常订单
export function errorOrderStatus(data) {
  return service({
    url: "offlinestore/agent.order/manageErrorOrder",
    method: "post",
    data: data
  });
}

// 油品异常订单
export function errorOrderDel(data) {
  return service({
    url: "offlinestore/agent.order/delErrorOrder",
    method: "post",
    data: data
  });
}

// 交班信息
export function changeDutyData(data) {
  return service({
    url: "offlinestore/agent.Changeduty/task_list",
    method: "post",
    data: data
  });
}

// 交班提交操作
export function changeDutySubmit(data) {
  return service({
    url: "offlinestore/agent.Changeduty/task_detail",
    method: "post",
    data: data
  });
}
// 交班删除操作
export function changeDuty_del(data) {
  return service({
    url: "offlinestore/agent.Offlineadminduty/del",
    method: "post",
    data: data
  });
}

// 交班历史记录
export function changeDutyList(data) {
  return service({
    url: "offlinestore/agent.Offlineadminduty/index",
    method: "post",
    data: data
  });
}

// 给员工交班
export function changeDutyForEmp(data) {
  return service({
    url: "offlinestore/agent.Changeduty/settelment",
    method: "post",
    data: data
  });
}

// 客户召回列表
export function userCallbackList(data) {
  return service({
    url: "user/agent.User_Call_Back/index",
    method: "post",
    data: data
  });
}
// 客户召回发送多张优惠券
export function userCallbackMoreTicket(data) {
  return service({
    url: "/user/agent.user_call_back/sendCoupon",
    method: "post",
    data: data
  });
}
// 客户召回发送单张优惠券
export function userCallbackSingleTicket(data) {
  return service({
    url: "/user/agent.user_call_back/sendSingleCoupon",
    method: "post",
    data: data
  });
}

// 基础统计
export function baseCount(data) {
  return service({
    url: "offlinestore/agent.count/base",
    method: "post",
    data: data
  });
}

// 今日销售统计
export function todayCount(data) {
  return service({
    url: "offlinestore/agent.count/todayCount",
    method: "post",
    data: data
  });
}

//会员备注
export function edit_vip_remark(data) {
  return service({
    url: "user/agent.user_level_card/edit_remark",
    method: "post",
    data: data
  });
}
//会员备注
export function user_level_card_info(data) {
  return service({
    url: "user/agent.user_level_card/info",
    method: "get",
    data: data
  });
}


// 会员生日统计
export function birthdayCount(data) {
  return service({
    url: "offlinestore/agent.count/birthday",
    method: "post",
    data: data
  });
}

// // 会员车辆信息
// export function vipCarMsg(data) {
//   return service({
//     url: "",
//     method: "post",
//     data: data
//   });
// }

// // 会员开票信息
// export function vipInvoiceMsg(data) {
//   return service({
//     url: "",
//     method: "post",
//     data: data
//   });
// }

// 确认未支付订单
export function confirmOrder(data) {
  return service({
    url: "offlinestore/agent.order/confirmOrder",
    method: "post",
    data: data
  });
}

// 删除未支付订单
export function cancelOrder(data) {
  return service({
    url: "offlinestore/agent.order/del",
    method: "post",
    data: data
  });
}

// 确认未支付充值订单
export function confirmRecharge(data) {
  return service({
    url: "offlinestore/agent.recharge/confirmOrder",
    method: "post",
    data: data
  });
}

// 删除未支付充值订单
export function cancelRecharge(data) {
  return service({
    url: "offlinestore/agent.recharge/del",
    method: "post",
    data: data
  });
}

// 给用户发送多个优惠券单张
export function sendCoupon(data) {
  return service({
    url: "coupon/agent.coupon/provide",
    method: "post",
    data: data
  });
}

// 给用户发送单个优惠券多张
export function sendCouponS(data) {
  return service({
    url: "coupon/agent.coupon/signle_provide",
    method: "post",
    data: data
  });
}

// 会员用户调级
export function changeUserLevel(data) {
  return service({
    url: "user/agent.User_Level_card/up_grade",
    method: "post",
    data: data
  });
}
// 加油卡
export function listRefule(data) {
  return service({
    url: "offlinestore/agent.Offline_Type_Card/index",
    method: "post",
    data: data
  });
}
export function addRefule(data) {
  return service({
    url: "offlinestore/agent.Offline_Type_Card/add",
    method: "post",
    data: data
  });
}
export function delRefule(data) {
  return service({
    url: "offlinestore/agent.Offline_Type_Card/del",
    method: "post",
    data: data
  });
}
export function editRefule(data) {
  return service({
    url: "offlinestore/agent.Offline_Type_Card/edit",
    method: "post",
    data: data
  });
}
export function detailRefule(data) {
  return service({
    url: "offlinestore/agent.Offline_Type_Card/detail",
    method: "post",
    data: data
  });
}

// 打开微信卡券
export function openWxCard(data) {
  return service({
    url: "wechat/agent.card/createCard",
    method: "post",
    data: data
  });
}

// 卡券颜色
export function getColor(data = {}) {
  return service({
    url: "wechat/agent.card/cardColor",
    method: "post",
    data: data
  });
}

// 开卡字段列表
export function getCardList(data) {
  return service({
    url: "wechat/agent.card/openData",
    method: "post",
    data: data
  });
}

// 卡券列表
export function getWeChatCardList(data) {
  return service({
    url: "wechat/agent.card/wechatCard",
    method: "post",
    data: data
  });
}

// 删除卡券
export function delWxCard(data) {
  return service({
    url: "wechat/agent.card/delCard",
    method: "post",
    data: data
  });
}

// 卡券详情
export function getWxCardDetail(data) {
  return service({
    url: "wechat/agent.card/cardDetail",
    method: "post",
    data: data
  });
}

// 编辑卡券
export function editWxCard(data) {
  return service({
    url: "wechat/agent.card/editCard",
    method: "post",
    data: data
  });
}

// 修改卡券字段
export function getWxEditCard(data) {
  return service({
    url: "wechat/agent.card/editOpenField",
    method: "post",
    data: data
  });
}

//新充值优惠添加
export function rechargeAdd(data) {
  return service({
    url: "api/config.recharge/add",
    method: "post",
    data: data
  });
}

//新充值优惠列表
export function rechargeList(data) {
  return service({
    url: "api/config.recharge/index",
    method: "post",
    data: data
  });
}

//新充值优惠编辑
export function rechargeEdit(data) {
  return service({
    url: "api/config.recharge/edit",
    method: "post",
    data: data
  });
}

//新充值优惠删除
export function rechargeDel(data) {
  return service({
    url: "api/config.recharge/del",
    method: "post",
    data: data
  });
}

//新充值优惠详情
export function rechargeDetail(data) {
  return service({
    url: "api/config.recharge/detail",
    method: "post",
    data: data
  });
}

// 班次设置列表
export function classSetList(data) {
  return service({
    url: "offlinestore/agent.Offline_class/index",
    method: "post",
    data: data
  });
}

// 班次设置添加
export function classSetAdd(data) {
  return service({
    url: "offlinestore/agent.Offline_class/add",
    method: "post",
    data: data
  });
}

// 班次设置修改
export function classSetEdit(data) {
  return service({
    url: "offlinestore/agent.Offline_class/edit",
    method: "post",
    data: data
  });
}

// 查看到期时间
export function getExpireTime(data) {
  return service({
    url: "api/meal/expire_time",
    method: "post",
    data: data
  });
}

// 套餐列表
export function getMeal(data) {
  return service({
    url: "api/meal/get_meal",
    method: "post",
    data: data
  });
}

// 续费扫码
export function feeQrcode(data) {
  return service({
    url: "api/meal/feeQrcode",
    method: "post",
    data: data
  });
}

// 查看续费支付状态
export function checkStatus(data) {
  return service({
    url: "api/meal/checkStatus",
    method: "post",
    data: data
  });
}

// 用户积分变动记录
export function getUserPointLogs(data) {
  return service({
    url: "user/agent.user/pointLogs",
    method: "post",
    data: data
  });
}

// 用户账户(会员卡，加油卡)
export function getUserAccount(data) {
  return service({
    url: "user/agent.user/userAccount",
    method: "post",
    data: data
  });
}

// 用户余额变动记录
export function getUserBalanceLogs(data) {
  return service({
    url: "user/agent.user/balanceLogs",
    method: "post",
    data: data
  });
}

// 会员一键开卡
export function oneOpenCard(data) {
  return service({
    url: "user/agent.User_Level_card/add_defult_user",
    method: "post",
    data
  });
}

// 会员可使用积分
export function get_point(data) {
  return service({
    url: "user/agent.user/get_point",
    method: "post",
    data
  });
}

// 获取会员优惠
export function getVipDiscount(data) {
  return service({
    url: "user/agent.User_level_card/preferential",
    method: "post",
    data
  });
}

// 获取优惠券信息
export function getAvailable_coupon(data) {
  return service({
    url: "coupon/agent.coupon/available_coupon",
    method: "post",
    data
  });
}
//获取用户手机号
export function admin_mobile(data) {
  return service({
    url: "user/user.index/mobile",
    method: "post",
    data
  });
}
//修改登录密码
export function passwordEdit(data) {
  return service({
    url: "manage/user.agent_user/password",
    method: "post",
    data
  });
}
export function admin_mobileEdit(data) {
  return service({
    url: "manage/user.agent_user/modify_mobile",
    method: "post",
    data
  });
}
//开票
export function saveReceipt(data) {
  return service({
    url: "user/user.receipt/saveReceipt",
    method: "post",
    data
  });
}
//订单状态查询
export function recharge_order_query(data) {
  return service({
    url: "manage/order.recharge/order_query",
    method: "post",
    data
  });
}
export function recharge_order_queryss(data) {
  return service({
    url: "user/agent.account/recharge_status",
    method: "post",
    data
  });
}

export function normal_order_Query(data) {
  return service({
    url: "manage/order.normal_order/order_query",
    method: "post",
    data
  });
}
export function offline_order_query(data) {
  return service({
    url: "manage/order.offline_order/order_query",
    method: "post",
    data
  });
}
// 提交订单
export function cashCreateOrder(data) {
  return service({
    url: "offlinestore/agent.order/createOrder",
    method: "post",
    data
  });
}
//创建订单(新)
export function CreateOrder_new(data) {
  return service({
    url: "manage/order.offline_order/create_order",
    method: "post",
    data
  });
}
// 用户是否2
export function judgePayPass(data) {
  return service({
    url: "user/agent.index/judgePayPass",
    method: "post",
    data
  });
}

// 优惠券任务列表
export function couponTaskList(data) {
  return service({
    url: "offlinestore/agent.task/index",
    method: "post",
    data: data
  });
}

// 优惠券任务继续执行
export function continueTask(data) {
  return service({
    url: "offlinestore/agent.task/goOnTask",
    method: "post",
    data: data
  });
}

// 列表导出方法
export function exportMethod(data) {
  var baseUrl = "https://www.58zltc.com/";
  if (localStorage.getItem("baseStatus") == "test") {
    baseUrl = "https://cs.58zltc.com/";
  }
  var linkUrl = baseUrl + data.Api + "?token=" + data.token;
  data.params.forEach(item => {
    linkUrl += "&" + item.name + "=" + item.value;
  });
  linkUrl += "&export_=1";
  console.log("linkUrl", linkUrl);
  window.location.href = linkUrl;
}
//订单导出
export function exportMethods(data) {
  var baseUrl = "https://www.58zltc.com/";
  if (localStorage.getItem("baseStatus") == "test") {
    baseUrl = "https://cs.58zltc.com/";
  }
  var linkUrl = baseUrl + data.Api + "?app_id=" + data.app_id;
  data.params.forEach(item => {
    linkUrl += "&" + item.name + "=" + item.value;
    // console.log(linkUrl)
  });
  // 	// linkUrl += "&export_=1";
  console.log("linkUrl", linkUrl);
  window.location.href = linkUrl;
}
// 列表导出(新)
export function addExportPlan(data) {
  return service({
    url: "api/plan/addPlan",
    data: data,
    method: "post"
  });
}

// 余额变动日志
export function getBalanceLog(data) {
  return service({
    url: "user/agent.logs/balanceLogs",
    method: "post",
    data: data
  });
}

// 积分变动日志
export function getPointLog(data) {
  return service({
    url: "user/agent.logs/pointLogs",
    method: "post",
    data: data
  });
}
// 开通小程序卡券
export function openMiniCard(data) {
  return service({
    url: "wechat/user.card/openMiniCard",
    method: "post",
    data: data
  });
}

// 消费订单 打印小票
export function orderPrint(data) {
  return service({
    url: "offlinestore/agent.order/print",
    method: "post",
    data: data
  });
}

// 充值订单 打印小票
export function rechargePrint(data) {
  return service({
    url: "offlinestore/agent.recharge/print",
    method: "post",
    data: data
  });
}

// 订单开票信息
export function orderReceiptMsg(data) {
  return service({
    url: "offlinestore/agent.order/get_receipt",
    method: "post",
    data: data
  });
}

// 确认开票
export function confirmReceipt(data) {
  return service({
    url: "offlinestore/agent.order/open_receipt",
    method: "post",
    data: data
  });
}
// 积分商品兑换
export function integralOrder(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/submit_order",
    method: "post",
    data: data
  });
}
export function integralOrders(data) {
  return service({
    url: "creditshop/agent.creditshop_goods_order/submit_shoporder",
    method: "post",
    data: data
  });
}

export function integralOrderDetail(data) {
  return service({
    url: "creditshop/agent.Creditshop_Goods_Order/detail",
    method: "post",
    data: data
  });
}

// 作废已支付的现金订单
export function cancalCashOrder(data) {
  return service({
    url: "offlinestore/agent.order/cancelPayOrder",
    method: "post",
    data: data
  });
}
// 删除订单
export function deleteFakeOrder(data) {
  return service({
    url: "offlinestore/agent.order/deleteOrder",
    method: "post",
    data: data
  });
}
// 删除订单
export function deleteFakeRechangeOrder(data) {
  return service({
    url: "offlinestore/agent.recharge/deleteRecharge",
    method: "post",
    data: data
  });
}
// 已作废订单列表
export function cancelOrderList(data) {
  return service({
    url: "offlinestore/agent.order/cancelOrder",
    method: "post",
    data: data
  });
}

// 已作废订单列表
export function getTypeCardList(data) {
  return service({
    url: "user/agent.UserLevelCard/get_cards",
    method: "post",
    data: data
  });
}
// 每升减。锁油价优惠
export function accountAvailable(data) {
  return service({
    url: "offlinestore/agent.order/account_available",
    method: "post",
    data: data
  });
}
// 散客设置
export function visitor_discount_setConfig(data) {
  return service({
    url: "manage/activity.visitor_discount/setConfig",
    method: "post",
    data: data
  });
}
// 散客详情
export function visitor_discount_configDetail(data) {
  return service({
    url: "manage/activity.visitor_discount/configDetail",
    method: "post",
    data: data
  });
}
export function TanKuang(data) {
  return service({
    url: "manage/activity.article/activity_info",
    method: "post",
    data: data
  });
}
export function setTanKuang(data) {
  return service({
    url: "manage/activity.article/activity_setting",
    method: "post",
    data: data
  });
}
export function getVipRemark(data) {
  return service({
    url: "user/agent.user/user_supplement",
    method: "post",
    data: data
  });
}
export function setVipRemark(data) {
  return service({
    url: "user/agent.user/edit_user_supplement",
    method: "post",
    data: data
  });
}
